module.exports = __webpack_public_path__ + "static/media/gcdef_10012.6d1833fa.ico";